// extracted by mini-css-extract-plugin
export var numpadContainer = "_r2-1";
export var phoneButton = "_r2-0";